import React, { useState, useEffect } from 'react';
import '../../App.css';

const FlipDigit = ({ char }) => {
  const [current, setCurrent] = useState(char);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (char !== current) {
      setAnimating(true);
      const timer1 = setTimeout(() => {
        setCurrent(char);
      }, 200); // Wait half of the animation
      const timer2 = setTimeout(() => {
        setAnimating(false);
      }, 400); // Total animation duration
      return () => { clearTimeout(timer1); clearTimeout(timer2); };
    }
  }, [char, current]);

  return (
    <div className={`flip-card ${animating ? 'flip-animate' : ''}`}>
      <div className="flip-card-inner">
        <span className="digit">{current}</span>
      </div>
    </div>
  );
};

// Settings Custom Components

export default FlipDigit;
